import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../api/services/user.service';
import { Organization, PaginatedOrganizationDTO  } from '../../../api/models/organization';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteModalComponent } from '../../delete-modal/delete-modal.component';
import { AuthService } from '../../../api/services/auth.service';
import { PaginatedRequest } from '../../../api/models/paginated-request';
import { Subject } from 'rxjs/Subject';
import { PreferencesService } from '../../../api/services/preferences.service';
import { RoleRequest } from '../../../api/models/role-assignment-map';
import { ToastrService } from 'ngx-toastr';
import { Market, MarketsInput } from '../../../api/models/market-model';
import { Address } from '../../../api/models/address';
import { BillTo } from '../../../api/models/bill-to';
import { MarketService } from '../../../api/services/market.service';
import { MarketEditComponent } from '../../market-edit/market-edit.component';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ProjectService } from '../../../api/services/project.services';

@Component({
  selector: 'app-market-list',
  templateUrl: './market-list.component.html',
  styleUrls: ['./market-list.component.scss']
})
export class MarketListComponent implements OnInit {

  constructor(
    private userService: UserService,
    private modalService: NgbModal,
    private authService: AuthService,
    private toastr: ToastrService,
    private preferencesService: PreferencesService,
    private marketService: MarketService,
    private projectService: ProjectService
  ) 
  {
    this.searchSubject.asObservable()
      .debounceTime(1000)
      .subscribe(marketSearchText => {
        if (marketSearchText) {
          this.marketSearchText = marketSearchText;
        }
        //this.loadPage(1);
      });
  }

  totalRecords = 0;
  sorting: string = 'customerName,name';
  paginatedRequest: PaginatedRequest;
  marketList: PaginatedOrganizationDTO;
  markets: Market[] = [];
  organizations: Organization[] = [];
  marketSearchText: string = "";
  searchSubject: Subject<string> = new Subject<string>();
  page = 1;
  pageSize = 50;
  loading = false;
  edit = false;
  marketSelected: Market;
  visibleContext = false;
  infoMsg = ['No records found!'];
  canDeleteMarket: boolean = false;
  canUpdateMarket: boolean = false;
  canCreateMarket: boolean = false;
  selectedSpecialField: string;
  specialFields: string[];
  isTesscoUser = false;
  marketsInput: MarketsInput;
  searchTextValue: string;
  highlightSearchButton: boolean = false;
  isModalOpen: boolean = false;
  isTesscoAdmin: boolean = false;
  isClientAdmin: boolean = false;
  orgId: string = '';
  @ViewChild('searchText') searchText: ElementRef;

  // Testing Organization Id
  //organizationId = 'c5b23111-2922-41fa-8918-611619fc2d9d';
  //organizationName = 'atcdasregproddev004 Client';

  createMarket() {
    this.openMarketModal('Create');
  }

  openMarketModal(action, market: Market = new Market({ customerId: '', customerName: '' }), addresses: Address[] = [], billTo: BillTo = new BillTo(), specialFieldValue: string = this.selectedSpecialField) {
    const modalRef = this.modalService.open(MarketEditComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });

    modalRef.result.then(() => {
      this.onUpdateSuccess();
      setTimeout(() => {this.loadPage(this.page);}, 400);
    }).catch(() => {
      
    });

    modalRef.componentInstance.market = market;
    modalRef.componentInstance.addresses = addresses;
    modalRef.componentInstance.action = action;
    modalRef.componentInstance.specialFieldValue = specialFieldValue;
    modalRef.componentInstance.billToAddress = billTo;
  }

  private getMarketsV2(orgId: string) {
    this.marketService.getMarkets(orgId)
      .subscribe(markets => {
        this.markets = markets
        this.markets = this.markets.filter(market => this.userService.isMarketPermittedForCurrentUser(market.id));
        this.loading = false;
      });
      
  }


  searchAllMarkets(value){
    if(!value){
      this.highlightSearchButton = false;
      this.searchTextValue = "";
      this.loadPage(1);
    } else {
      this.highlightSearchButton = true;
    }
  }

  searchMarket(value) {
    this.page = 1;
    if (value && value.trim().length > 0) {
      this.searchTextValue = value.trim();
    } else {
      this.searchTextValue = "";
    }
    this.loadPage(this.page);
  }

  loadPage(page){
    this.loading = true;
    //this.getMarketsV2(this.organizationId);
    this.marketsInput = new MarketsInput();
    this.marketsInput.marketIds = this.userService.getMarketPermittedForCurrentUser();
    this.marketsInput.searchTerm = this.searchTextValue;
    if(this.orgId != "ALL" && this.orgId != ""){ this.marketsInput.orgId = this.orgId; }
    this.paginatedRequest = new PaginatedRequest(page, this.pageSize, this.sorting);
    this.marketService.getMarketsListMinimalInfo(this.paginatedRequest, this.marketsInput).subscribe(paginatedResponse => {
      this.markets = paginatedResponse.records;
      this.totalRecords = paginatedResponse.totalRecords;
      this.loading = false;
    }, error => {
      this.markets = [];
      this.totalRecords = 0;
      this.loading = false;
    });
  }

  editMarket(market: Market) {
    if(!this.isModalOpen){
      this.isModalOpen = true;
      // Getting the full Market details for Edit purpose. In the Beginning we are getting only minimal Details 
      this.marketService.getMarketById(market.id).subscribe(mkt => {
        this.callToEditOpenModal(mkt); 
      });
      setTimeout(() => {
        this.isModalOpen = false;
      }, 1500);
    }
  }

  callToEditOpenModal(market: Market){
    forkJoin(this.marketService.getAddresses(market.id), this.marketService.getBillingAddresses(market.id))
      .subscribe(addresses => {
        this.openMarketModal('Edit', market, addresses[0], addresses[1]);
      });
  }

  private onUpdateSuccess() {
    this.toastr.success('Market saved!!!', 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  deleteMarket(market: Market) {
    this.projectService.getActiveProjectCount(market.id).subscribe(count => {
      const modalRef = this.modalService.open(DeleteModalComponent, {
        backdrop: 'static',
        keyboard: false
      });

      modalRef.componentInstance.name = market.name;
      let additionalMsg = '';
      if(count > 0) {
        if(count === 1) {
          additionalMsg = `There is <strong>${count} active project</strong> associated with this market. `;
        } else {
          additionalMsg = `There are <strong>${count} active projects</strong> associated with this market. `; 
        }
      }  
      modalRef.componentInstance.bodyMsg = additionalMsg + `Are you sure you want to delete the market <strong>${market.name}</strong>?`;
      modalRef.componentInstance.fn = () => {
        const id = market.id;
        this.marketService.deleteMarket(id)
          .subscribe(() => {
            modalRef.close();
            this.markets = this.markets.filter(m => m.id !== market.id);
          });
      };
    });
  }

  setClient(clientId: string) {
    this.orgId = clientId;
    this.page = 1;
    this.loadPage(1);
  }


  ngOnInit() {
    
    //this.checkPermissions();
    //this.getSpecialFieldsPreferences(this.organizationId);
    
    this.userService.findUserById(this.authService.getUserId())
    .switchMap(user => this.authService.getUserRolesInContext(`ORGANIZATION~${user['Organization ID']}`))
    .subscribe(roles => {
      if (roles.includes('TESSCO')) {this.isTesscoUser = true;}
      if(roles.includes('MARKET_DELETE')){ this.canDeleteMarket = true;}
      if(roles.includes('MARKET_UPDATE')){ this.canUpdateMarket = true;}
      if(roles.includes('MARKET_CREATE')){ this.canCreateMarket = true;}
      if(roles.includes('ADMIN_TESSCO')){this.isTesscoAdmin = true;}
      

      this.userService.getOrganizations().subscribe(orgs => {
        this.organizations = orgs;
        if(this.isTesscoAdmin){
          let organization = new Organization();
          organization.Name = "ALL";
          organization['Organization ID'] = "ALL";
          // Adding ALL option as first element in the Array
          this.organizations.unshift(organization);
        }
        if(this.organizations.length ==1){this.setClient(this.organizations[0]['Organization ID']);}
      });
    });

    
    this.loadPage(1);
  }
  
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/management/market-list/market-list.component.ts